import { KipReport } from '../types';

export const mockReports: KipReport[] = [
  {
    id: '1',
    kipId: '1',
    date: 'August 1, 2025',
    time: '3:30 PM',
    duration: '12 min 45 sec',
    therapist: 'Bryce',
    simulatedParent: 'Allison Thompson',
    client: 'Billy Thompson',
    scores: {
      communicationSkills: 4,
      bedsideManner: 5,
      clinicalAccuracy: 3,
      goalAchievement: 4,
      abaSkills: 4,
    },
    scoreNotes: {
      communicationSkills: 'Generally clear, occasional rushed sections',
      bedsideManner: 'Warm, empathetic, responsive to emotion',
      clinicalAccuracy: 'Minor inconsistency in reinforcement timeline',
      goalAchievement: 'Parent confirmed understanding and next steps',
      abaSkills: 'Concepts applied correctly with good examples',
    },
    feedback: {
      communicationSkills: {
        score: 4,
        details: [
          'Pace: Started quickly, improved pacing by mid-call',
          'Enunciation: Slight mumbling during minute 2',
          'Listening: Used paraphrasing well'
        ],
        highlight: '"So you\'re saying Billy has been resisting the cleanup routine more often this week?"'
      },
      bedsideManner: {
        score: 5,
        details: [
          'Tone: Consistently warm and encouraging',
          'Empathy: Validated parent frustrations',
          'Professionalism: Clear and supportive boundaries'
        ],
        highlight: '"It sounds like it\'s been a tough week. You\'re doing a great job sticking with the plan."'
      },
      clinicalAccuracy: {
        score: 3,
        details: [
          'Correct Use: DRA and token economy used properly',
          'Error: Incorrect start date of reinforcement plan'
        ],
        warning: 'Double-check service logs before calls for accurate communication.'
      },
      goalAchievement: {
        score: 4,
        details: [
          'Outcome: Parent agreed to next steps and tools',
          'Closure: Clear summary + scheduled next check-in'
        ]
      },
      abaSkills: {
        score: 4,
        details: [
          'Used: DRA, token economy, prompt fading',
          'Good examples but missed chance to explain "extinction burst"'
        ]
      }
    },
    transcriptHighlights: [
      {
        type: 'correct',
        speaker: 'Therapist',
        text: 'We\'re using a DRA by reinforcing Billy when he asks for a break instead of dropping to the floor.',
        note: 'Correct Concept Use'
      },
      {
        type: 'warning',
        speaker: 'Therapist',
        text: 'We started the sticker plan last Monday.',
        note: 'Timeline Inaccuracy – Should be Wednesday'
      },
      {
        type: 'correct',
        speaker: 'Therapist',
        text: 'That could be an extinction burst. I\'ll explain more...',
        note: 'Recognition – More explanation needed'
      }
    ],
    summary: {
      strengths: [
        'Empathy and professionalism',
        'Used clear, developmentally appropriate examples',
        'Parent left with clear understanding of plan'
      ],
      growthAreas: [
        'Verify treatment details before calls',
        'Improve technical clarity and pacing',
        'Explain complex terms with simple analogies'
      ]
    },
    suggestedFollowUp: [
      {
        type: 'Scenario',
        title: 'Explaining ABA Concepts to Parents Under Stress – Level 2'
      },
      {
        type: 'Micro-Training',
        title: 'Mastering Pacing During Technical Explanations'
      }
    ]
  },
  {
  id: '2',
  kipId: '2',
  date: 'August 1, 2025',
  time: '4:15 PM',
  duration: '10 min 10 sec',
  therapist: 'Bryce',
  simulatedParent: 'Allison Thompson',
  client: 'Billy Thompson',
  scores: {
    communicationSkills: 5,
    bedsideManner: 5,
    clinicalAccuracy: 4,
    goalAchievement: 4,
    abaSkills: 4,
  },
  scoreNotes: {
    communicationSkills: 'Clear explanation, paused appropriately for parent questions',
    bedsideManner: 'Supportive and encouraging throughout',
    clinicalAccuracy: 'Accurate summary of intake findings, slight generalization on skill level',
    goalAchievement: 'Parent left with clarity on treatment roadmap',
    abaSkills: 'Used intake data to suggest appropriate strategies',
  },
  feedback: {
    communicationSkills: {
      score: 5,
      details: [
        'Pacing: Steady with pauses for check-ins',
        'Clarity: Definitions explained clearly',
        'Listening: Repeated and validated parent comments'
      ],
      highlight: '"So based on what you’ve shared, and what we observed, routines and visuals will really help Billy succeed."'
    },
    bedsideManner: {
      score: 5,
      details: [
        'Tone: Gentle and reassuring',
        'Empathy: Acknowledged parent’s feelings of overwhelm',
        'Support: Reinforced strengths of the child'
      ],
      highlight: '"Billy clearly has a sharp memory—that’s going to be a real strength as we build routines."'
    },
    clinicalAccuracy: {
      score: 4,
      details: [
        'Reported milestones accurately',
        'Slight overstatement of verbal skills range'
      ],
      warning: 'Stick closely to assessment terms when summarizing developmental levels.'
    },
    goalAchievement: {
      score: 4,
      details: [
        'Reviewed short- and long-term goals',
        'Clarified what to expect in the first 30 days'
      ]
    },
    abaSkills: {
      score: 4,
      details: [
        'Applied visual schedules and token economy to plan',
        'Suggested starting with PECS for requesting'
      ]
    }
  },
  transcriptHighlights: [
    {
      type: 'correct',
      speaker: 'Therapist',
      text: 'Given Billy’s strong visual skills, we’ll start with a visual schedule and gradually introduce choice boards.',
      note: 'Correct strategy alignment'
    },
    {
      type: 'warning',
      speaker: 'Therapist',
      text: 'His language is almost at a conversational level.',
      note: 'Overgeneralization – better to say “emerging phrases”'
    }
  ],
  summary: {
    strengths: [
      'Reinforced parental understanding with warmth',
      'Appropriate ABA recommendations based on intake',
      'Strong use of plain language'
    ],
    growthAreas: [
      'Avoid overgeneralizing skill levels',
      'Offer fewer strategies at once for clarity'
    ]
  },
  suggestedFollowUp: [
    {
      type: 'Scenario',
      title: 'Simplifying Clinical Language for New Parents'
    },
    {
      type: 'Micro-Training',
      title: 'Goal Prioritization in Early Parent Meetings'
    }
  ]
},
  {
  id: '3',
  kipId: '3',
  date: 'July 22, 2025',
  time: '2:05 PM',
  duration: '11 min 32 sec',
  therapist: 'Jordan',
  simulatedParent: 'Lucia Rodriguez',
  client: 'Maya Rodriguez',
  scores: {
    communicationSkills: 4,
    bedsideManner: 4,
    clinicalAccuracy: 5,
    goalAchievement: 3,
    abaSkills: 5,
  },
  scoreNotes: {
    communicationSkills: 'Clear summary, slightly rushed at times',
    bedsideManner: 'Supportive with moments of slight formality',
    clinicalAccuracy: 'Excellent tracking and reporting of data',
    goalAchievement: 'Needs clearer next-step planning',
    abaSkills: 'Strategies were data-based and well explained',
  },
  feedback: {
    communicationSkills: {
      score: 4,
      details: [
        'Summary: Clear but used some jargon ("self-regulation")',
        'Listening: Good back-and-forth with guardian',
        'Delivery: Slightly fast during intervention explanation'
      ],
      highlight: '"She’s starting to use deep breathing without being prompted—about 3 times this week!"'
    },
    bedsideManner: {
      score: 4,
      details: [
        'Professional and affirming',
        'Could pause more after parent reactions'
      ],
      highlight: '"That’s a great observation—you’re picking up on key patterns with her behavior."'
    },
    clinicalAccuracy: {
      score: 5,
      details: [
        'Progress data well cited',
        'Intervention changes matched observation trends'
      ]
    },
    goalAchievement: {
      score: 3,
      details: [
        'Summarized progress well',
        'Lacked a concrete “next step” roadmap for month 2'
      ],
      warning: 'Always include a written or verbal plan for next phase goals.'
    },
    abaSkills: {
      score: 5,
      details: [
        'Excellent use of behavior momentum and reinforcement fading',
        'Described function-based changes clearly'
      ]
    }
  },
  transcriptHighlights: [
    {
      type: 'correct',
      speaker: 'Therapist',
      text: 'We shifted reinforcement to occur after two instances of waiting instead of one.',
      note: 'Good fading technique'
    },
    {
      type: 'warning',
      speaker: 'Therapist',
      text: 'We’ll keep the same exact plan for the next 30 days.',
      note: 'Missed chance to discuss adaptive next steps'
    }
  ],
  summary: {
    strengths: [
      'Data-informed explanation of behaviors',
      'Validated parent’s insights',
      'High clinical accuracy'
    ],
    growthAreas: [
      'Give clearer guidance on upcoming changes',
      'Slow down when sharing technical details'
    ]
  },
  suggestedFollowUp: [
    {
      type: 'Scenario',
      title: 'Planning Next Steps in Progress Reviews'
    },
    {
      type: 'Micro-Training',
      title: 'Balancing Detail and Clarity in Parent Reports'
    }
  ]
}

];